//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'SeekerItem',
  props: {
    item: { type: Object, default: () => {} },
    details: { type: Boolean, default: false },
    jobPositionId: { type: String, default: '' },
  },
  computed: {
    ...mapGetters('common', ['areaLocalTree', 'jobCatTree']),
    // 取得職缺名稱
    jobCatName() {
      const key1 = jobCatId => jobCatId.slice(1, 3) - 1;
      const key2 = jobCatId => jobCatId.slice(3, 5) - 1;

      return this.item.jobCatIds
        .map(jobCatId =>
          key2(jobCatId) === -1
            ? this.jobCatTree[key1(jobCatId)].label
            : this.jobCatTree[key1(jobCatId)].children[key2(jobCatId)].label,
        )
        .join(', ');
    },
    // 取得地點名稱
    areaLocalName() {
      if (isEmpty(this.item.areaIds)) return '';

      const key1 = areaId => areaId.slice(4, 7) - 1;
      const key2 = areaId => areaId.slice(7, 10) - 1;

      const taiwanArea = this.areaLocalTree;

      return this.item.areaIds
        .map(areaId =>
          key2(areaId) === -1
            ? taiwanArea[key1(areaId)].label
            : taiwanArea[key1(areaId)].children[key2(areaId)].label,
        )
        .join(', ');
    },
  },
  methods: {
    gotoDetails() {
      if (!this.item.userApplicantId) return;
      this.$router.push(
        `/Owner/Seeker/${this.item.userApplicantId}?jobPositionId=${this.jobPositionId}`,
      );
    },
  },
};
